import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { License } from '../../opds2';
import { UtilMixin } from '../../UtilMixin';

@Component({ components: {} })
export default class AcceptRejectForm extends Mixins(UtilMixin) {
  @Prop() public suggestion!: any;

  public countModel = 1;
  public licenses: License[] = [];
  public selectedLicense: any = {};

  @Emit()
  public update(
    entryId: string,
    code: string,
    licenseId: string,
    count: number
  ) {
    console.log(`updating ${entryId} ${code} ${licenseId} ${count}`);
    if (code === 'REJECTED') {
      // Reset the default values, just to be synchro.
      this.countModel = 1;
      this.selectedLicense = this.findDefaultLicense(
        this.suggestion.publication
      );
    }
  }

  public mounted() {
    this.countModel = this.suggestion.status.count;
    this.licenses = this.suggestion.publication.licenses.map((l: License) => {
      return {
        value: l,
        text: this.$options!.filters!.license(l),
      };
    });
    this.selectedLicense = this.suggestion.publication.licenses.find(
      (l: License) => l.metadata.identifier === this.suggestion.status.licenseId
    );
  }
}
